import Axios from 'axios';
import React from "react";
import ReactGooglePlacesSuggest from "react-google-places-suggest";
import { GOOGLE_API_KEY } from '../../../constants/api-constants';
import "./google-api-places.scss";

export default class googleApiPlaces extends React.Component {

  handleInputChange = e => {
    this.props.setAdress({ search: e.target.value, value: e.target.value })
  }

  handleSelectSuggest = (geocodedPrediction, originalPrediction) => {

    const GOOGLE_API_KEY_II = "AIzaSyBfSCVlIfp7EEmQP9r68O2ffRrpMqA1Qn0";
    console.log("place_id", geocodedPrediction.place_id);

    Axios.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + geocodedPrediction.place_id + "&key=" + GOOGLE_API_KEY_II).then(resp => {
      console.log("resp", resp);
      var results = resp.data.results[0].geometry.location;

      this.props.setDefaulGeo({
        center: {
          lat: results.lat,
          lng: results.lng
        },
        zoom: 17
      });

      this.props.setCorMarket({
        lat: results.lat,
        lng: results.lng
      });

    })
    this.props.setAdress({ search: "", value: geocodedPrediction.formatted_address })
  }

  handleNoResult = () => {
    // console.log("No results for ", this.props.adress.search)
  }

  handleStatusUpdate = status => {
    // console.log(status)
  }

  render() {
    const { search, value } = this.props.adress
    return (
      // <ReactGoogleMapLoader
      //     params={{
      //         key: MY_API_KEY,
      //         libraries: "places,geocode",
      //     }}
      //     render={googleMaps =>
      //         googleMaps && (
      <>
        {this.props.googleMaps && <ReactGooglePlacesSuggest
          googleMaps={this.props.googleMaps}
          autocompletionRequest={{
            input: search,
            // Optional options
            // https://developers.google.com/maps/documentation/javascript/reference?hl=fr#AutocompletionRequest
          }}
          // Optional props
          onNoResult={this.handleNoResult}
          onSelectSuggest={this.handleSelectSuggest}
          onStatusUpdate={this.handleStatusUpdate}
          textNoResults="No se encuentra la dirección" // null or "" if you want to disable the no results item
          customRender={prediction => (
            <div className="f-customWrapper">
              <span className="pac-icon"></span>
              {prediction
                ? prediction.description
                : "No se encuentra la dirección"}
            </div>
          )}
        >
          <input
            type="text"
            value={value}
            placeholder="Dirección"
            onChange={this.handleInputChange}
            className="f-register-address-additional"
          />
        </ReactGooglePlacesSuggest>}
      </>
      //         )
      //     }
      // />
    )
  }
}